import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { styles } from './styles.css';
import { Link } from 'react-router-dom';

export default class Logo extends Component {
  render() {
    return (
      <div className={classNames(styles, 'col-xs-8', 'col-sm-6')}>
        <span className="logo"><Link to="/">daniel seripap</Link></span>
      </div>
    );
  }
}
